import { PAGES } from '@/constants/pages';
import { ORDER_STATUS } from '@/constants/variables';

export default {
  getTriggerUpdateOrdersList: state => {
    return state.triggerUpdateOrdersList;
  },

  getStatusList(state) {
    return state.statusList || [];
  },

  filterStatusList: (state, getters) => status => {
    const fullStatusList = [...getters.getStatusList, ORDER_STATUS.DRAFT]
    status = status.split(',');
    const list = fullStatusList.filter(item => status.includes(item.id.toString()));
    let result = list.map(item => item.vendor_code);

    return result;
  },

  filterEmployeeList: (state, getters, rootState) => employees => {
    const list = rootState.account.employees.filter(item => employees.includes(item.id.toString()));
    let result = list.map(item => item.id);

    return result;
  },

  getOrderDetailUiid: state => {
    const order = state.orderDetail;
    return order ? order.uuid : '';
  },

  isRetail(state, getters, rootState) {
    if (rootState.common.route?.name === PAGES.orders.retail.name) {
      return true;
    }

    return false;
  },

  isSupplier(state, getters, rootState) {
    if (rootState.common.route?.name === PAGES.orders.supplier.name) {
      return true;
    }

    return false;
  },

  getIsSupplierDealerReclamation: (state, getters, rootState) => order => {
    if (getters.isSupplier) {
      const dealerId = order?.dealer?.id;
      const statusId = order?.status?.id;

      if (dealerId === 1 && statusId) {
        const statusFind = state.statusList?.find(item => item.id === statusId);

        if (statusFind?.sort_order > 100) {
          return false;
        }
      }
    }

    return true;
  },

  isDealer(state, getters, rootState) {
    if (rootState.common.route?.name === PAGES.orders.dealer.name) {
      return true;
    }

    return false;
  },

  isReport(state, getters, rootState) {
    if (rootState.common.route?.name === PAGES.reports.name) {
      return true;
    }

    return false;
  },

  isArchive(state, getters, rootState) {
    if (rootState.common.route?.query?.tab === 'archived') {
      return true;
    }

    return false;
  },

  isZgi(state) {
    if (state.orderDetail?.content_type === 'ZGI') {
      return true;
    }

    return false;
  },

  isOpt(state) {
    if (state.orderDetail?.content_type === 'OPT') {
      return true;
    }

    return false;
  },

  getConfigOrders(state, getters, rootState) {
    const access = rootState.user.configAccess;
    let result = 0;

    if (access?.orders) {
      if (getters.isSupplier) {
        result = access.orders.suppliers.orders;
      } else if (getters.isDealer) {
        result = access.orders.dealers.orders;
      } else if (getters.isRetail) {
        result = access.orders.retails.orders;
      }
    }

    return result;
  },

  hasEmployeeId(state, getters, rootState) {
    const order = state.orderDetail;

    if (order) {
      if (order.employee?.id === rootState.user.userInfo.id || !order.employee) {
        return true;
      }
    }

    return false;
  },

  hasEmployeeMadeId(state, getters, rootState) {
    const order = state.orderDetail;

    if (order) {
      if (order.made_by_employee?.id === rootState.user.userInfo.id || !order.made_by_employee) {
        return true;
      }
    }

    return false;
  },

  canEdit(state, getters, rootState) {
    const config = getters.getConfigOrders;
    const employee = getters.isSupplier ? getters.hasEmployeeMadeId : getters.hasEmployeeId;

    let result = false;

    if (config === 2 || (config === 1 && employee)) {
      result = true;
    } else {
      result = false;
    }

    return result;
  },

  getHideBlock: (state, getters, rootState) => content_type => {
    if (getters.isSupplier) {
      return rootState.user.config.hide_blocks.price[content_type.toLowerCase()];
    }

    return false;
  },
};
